/** Senha temporária aleatória que cumpre a política (letra + número, 12 caracteres). */
export function generatePassword(length = 12): string {
  const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz';
  const digits = '23456789';
  const all = letters + digits;
  const bytes = new Uint32Array(length);
  crypto.getRandomValues(bytes);
  const chars = Array.from(bytes, (b, i) =>
    i === 0
      ? letters[b % letters.length]
      : i === 1
        ? digits[b % digits.length]
        : all[b % all.length],
  );
  // embaralha para a letra/dígito garantidos não ficarem sempre no início
  for (let i = chars.length - 1; i > 0; i--) {
    const j = bytes[i]! % (i + 1);
    [chars[i], chars[j]] = [chars[j]!, chars[i]!];
  }
  return chars.join('');
}
